"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaFirstIncorporated = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const Size_1 = require("../render/Size");
const Card_1 = require("../Card");
class LunaFirstIncorporated extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.LUNA_FIRST_INCORPORATED,
            tags: [Tags_1.Tags.MOON],
            startingMegaCredits: 40,
            metadata: {
                description: 'You start with 40 M€, 2 steel and 2 titanium.',
                cardNumber: 'MC6',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.megacredits(40).steel(2).titanium(2).nbsp();
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect(undefined, (eb) => {
                            eb.moonColonyRate({ size: Size_1.Size.SMALL }).any.slash(Size_1.Size.LARGE)
                                .moonMiningRate({ size: Size_1.Size.SMALL }).any.slash(Size_1.Size.LARGE)
                                .moonLogisticsRate({ size: Size_1.Size.SMALL }).any
                                .startEffect.megacredits(1);
                        });
                        ce.vSpace();
                        ce.effect(undefined, (eb) => {
                            eb.moonColonyRate({ size: Size_1.Size.SMALL }).slash(Size_1.Size.LARGE)
                                .moonMiningRate({ size: Size_1.Size.SMALL }).slash(Size_1.Size.LARGE)
                                .moonLogisticsRate({ size: Size_1.Size.SMALL })
                                .startEffect.production((pb) => pb.megacredits(1));
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.text('(Effect: When any player raises a Moon rate, gain 1 M€ per step. When you raise a Moon rate, gain 1 M€ production per step.)', Size_1.Size.TINY, false, false);
                    });
                }),
            },
        });
    }
    play(player) {
        MoonExpansion_1.MoonExpansion.moonData(player.game).lunaFirstPlayer = player;
        player.steel += 2;
        player.titanium += 2;
        return undefined;
    }
}
exports.LunaFirstIncorporated = LunaFirstIncorporated;
//# sourceMappingURL=LunaFirstIncorporated.js.map